import React, { useEffect, useState } from "react";
import './TablaBitacoras.scss'
import ButtonGris from "../../atoms/ButtonGris/ButtonGris";
import Button from "../../atoms/Button/Button";
import InputLista from "../../atoms/InputLista/InputLista";
import TextArea from "../../atoms/TextArea/TextArea";
import { cancelarServicio, getCancelados, getCausa, getIncidentes } from "./TablaBitacorasntegracion";
import { jwtDecode } from "jwt-decode";
import { formateoBasico } from "../../../utilities/formateos";

const ModalCancelarServicio = ({ data, setShowCancelarServicio }) => {
    const [motivo, setMotivo] = useState(null)
    const [incidente, setIncidente] = useState(null)
    const [incidentes, setIncidentes] = useState([])
    const [fecha, setFecha] = useState(formateoBasico(new Date()))
    const [cancelados, setCancelados] = useState(formateoBasico(new Date()))
    useEffect(() => {
        getCausa(setIncidentes)
        getCancelados(data.bitacora, setCancelados)
    }, [])

  
    const sumbit = () => {
        const dataToken = jwtDecode(sessionStorage.getItem('token'))

        const dataSend = {
            id_incidente: incidente?.code,
            id_bitacora: data.bitacora,
            motivo: motivo,
            id_usuario: dataToken.ID,
            id_unidad: data.id_unidad,
            fecha: fecha
        }
        cancelarServicio(dataSend, setShowCancelarServicio)
    }
    return (
        <div className="modalContorn">
            <div className="modal">
                <div className="titleN">Cancelar Servicio : {data.bitacora}</div>
                <div className="titleN">{data.ruta} </div>
                <div className="titleN">{data.nombre}</div>
                <div className="margen">

                    {
                        cancelados.CANCELADO ?
                            <>
                                <div className="cancelado">{cancelados.MOTIVO_CANCELACION?cancelados.MOTIVO_CANCELACION:"Este servicio ya ha sido cancelado."}</div>
                                <div className="containerButtons">
                                    <ButtonGris onClick={() => { setShowCancelarServicio(null) }}>Salir</ButtonGris>
                                </div>
                            </> :
                            <>
                                <TextArea titulo={"Motivo"} value={motivo} onChange={(e) => { setMotivo(e.target.value) }} className={"textAreaClass"}></TextArea>
                                <InputLista options={incidentes} onChange={(e) => { setIncidente(e.value) }} value={incidente} titulo={"Incidente"}></InputLista>

                                <div className="containerButtons">
                                    <ButtonGris onClick={() => { setShowCancelarServicio(null) }}>Cancelar</ButtonGris>
                                    <Button disabled={motivo && incidente ? false : true} onClick={() => { sumbit() }}>Registrar</Button>
                                </div>
                            </>

                    }
                </div>
            </div>
        </div>
    )
}
export default ModalCancelarServicio